import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=2445cb4a"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2445cb4a')) {
      api.createRecord('2445cb4a', component.options)
    } else {
      api.reload('2445cb4a', component.options)
    }
    module.hot.accept("./Pago.vue?vue&type=template&id=2445cb4a", function () {
      api.rerender('2445cb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Pago.vue"
export default component.exports